import React, { useState } from "react";
import "./Sankalp_Notes_Modal.css";
import { Modal, Form } from "react-bootstrap";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Success_Modal from "../../common_modal/success_modal/Success_Modal";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { AddSankalpNote, UserSankalpNote } from "../../../../features/my_account/Slice";

const Sankalp_Notes_Modal = ({ modalTitle, ...props }) => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(AddSankalpNote(data));

      if (res?.meta?.requestStatus === "fulfilled") {
        props?.onHide();
        setShowSucsessModal(true);
        reset();
        await dispatch(UserSankalpNote());


        setTimeout(() => {
          setShowSucsessModal(false);
        }, 3000000);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Sankalp_Notes_Modal"
      >
        <Modal.Body>
          <form >
            <div className="content_div">
              <p className="label_text">{modalTitle}</p>

              {/* NAME FIELD */}
              <Form.Group className="gray_input_group input_group">
                <Form.Label>Note Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Note Title..."
                  {...register("name", {
                    required: "Title is required",
                    minLength: {
                      value: 3,
                      message: "Minimum 3 characters",
                    },
                  })}
                />
                {errors.name && (
                  <p className="text-danger">{errors.name.message}</p>
                )}
              </Form.Group>

              {/* DESCRIPTION FIELD */}
              <Form.Group className="gray_input_group input_group">
                <Form.Label>Note Description</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Type here..."
                  {...register("description", {
                    required: "Description is required",
                    minLength: {
                      value: 5,
                      message: "Minimum 5 characters",
                    },
                  })}
                />
                {errors.description && (
                  <p className="text-danger">{errors.description.message}</p>
                )}
              </Form.Group>

              <div className="btn_holder">
                <Orange_Btn
                  btnText={"Save"}
                  onClick={handleSubmit(onSubmit)}
                />

                <Light_Black_Btn
                  btnText={"Cancel"}
                  onClick={() => props?.onHide()}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        // onHide={() => setShowSucsessModal(false)}
        successText="Note Added Successfully!"
      />
    </>
  );
};

export default Sankalp_Notes_Modal;
